import { render, staticRenderFns } from "./Reglamentos.vue?vue&type=template&id=a2e8fa92"
import script from "./Reglamentos.vue?vue&type=script&lang=js"
export * from "./Reglamentos.vue?vue&type=script&lang=js"
import style0 from "./Reglamentos.vue?vue&type=style&index=0&id=a2e8fa92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports